module.exports = __webpack_public_path__ + "static/talk7-ffe954fa0a5add0c313a5bdeb4f8efbb.png";